module.exports = __webpack_public_path__ + "img/bnr_app@2x.1c3d40d0.png";